import type { HttpErrorResponse } from '@angular/common/http';

import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import {
  ISortEventArgs,
  TSortDirections,
} from 'src/app/shared/classes/grid-page-info';
import { IProvider } from 'src/app/shared/interfaces/provider/provider.interfaces';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UserStateService } from 'src/app/shared/services/users/user-state.service';
import { DEFAULT_MODAL_OPTIONS } from 'src/app/shared/variables/variables';

import { EditProviderModalComponent } from './../edit-provider-modal/edit-provider-modal.component';

@Component({
  selector: 'providers-grid',
  templateUrl: './providers-grid.component.html',
  styles: [':host { height: 100%; overflow: hidden;}'],
})
export class ProvidersGridComponent implements OnDestroy, OnInit {
  @Input() providers?: IProvider[];

  @Output() create = new EventEmitter();
  @Output() editComplete = new EventEmitter<IProvider>();
  @Output() providersScroll = new EventEmitter();
  @Output() sort = new EventEmitter();
  @Input() sortDirections: TSortDirections;
  @Input() moreRowsExists = false;
  @Input() headers: HeadersOptions = {};

  private subscriptions: Subscription = new Subscription();
  isLoading: boolean;
  isViewOnly: boolean;

  constructor(
    private alertService: AlertService,
    private modal: NgbModal,
    private userStateService: UserStateService,
  ) {}

  ngOnInit(): void {
    const currentUser = this.userStateService.user;
    const permissions = currentUser?.permissions;
    const containsAccounts = permissions?.some((permission) => {
      return (
        permission.name === 'Accounts' ||
        permission.name === 'Client Admin - Accounts'
      );
    });
    this.isViewOnly = !containsAccounts;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  doCreate() {
    this.create.emit();
  }

  doScroll() {
    this.providersScroll.emit();
  }

  callOnSort(sortBy: ISortEventArgs) {
    this.sort.emit(sortBy);
  }

  doEdit(provider?: IProvider) {
    if (!provider) {
      this.alertService.error(
        'Invalid operation',
        'Invalid component usage, ther is no provider to edit.',
      );
      return;
    }

    const modal = this.modal.open(EditProviderModalComponent, {
      ...DEFAULT_MODAL_OPTIONS,
      size: 'md',
      scrollable: false,
    });

    const mi = modal.componentInstance as EditProviderModalComponent;

    mi.providerId = provider.id;

    modal.result.then(
      (result) => {
        this.editComplete.emit(result as IProvider);
      },
      (error: unknown) => {
        if (error) {
          this.alertService.error(error as HttpErrorResponse | string);
        }
      },
    );
  }
}

type HeadersOptions = {
  disableAdd?: boolean;
};
